import { Component, Input, OnInit } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-code-rendered',
  templateUrl: './code-rendered.component.html',
  styleUrls: ['./code-rendered.component.css']
})
export class CodeRenderedComponent extends ElementComponent implements OnInit {
  @Input() override data: any = {}

  userTheme: string = "vs-dark";

  editorOptions: any = { };

  ngOnInit() {
    this.editorOptions = {
      theme: this.userTheme,
      language: this.data.codeLang,
      roundedSelection: true,
      autoIndent: true,
      readOnly: true,
      // contextmenu: false,
      readOnlyMessage: "",
      scrollbar: {
        alwaysConsumeMouseWheel: false
      }
    };
  }

}
